<!-- 首页内容渲染 -->
<template>
  <div>
    <!-- 渲染出口 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script> 

<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  margin: 0px;
  padding: 0px;
}

li {
  display: inline-block;
  margin: 0px;
}

a {
  color: #42b983;
}

body {
  background-color: #F2F2F2;
  margin: 0px;
  padding: 0px;
  height:100%;
  min-height:100%;
  _height:100%; 
  letter-spacing:1px;
}

.clear{
  clear: both;
}

</style>


// WEBPACK FOOTER //
// App.vue?5c904a5b